"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconAlertCircleFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm.92,13.38a1.15,1.15,0,0,1-.21.33,1.15,1.15,0,0,1-.33.21.94.94,0,0,1-.76,0,.9.9,0,0,1-.54-.54.94.94,0,0,1,0-.76,1,1,0,0,1,.21-.33,1.15,1.15,0,0,1,.33-.21,1,1,0,0,1,1.09.21,1,1,0,0,1,.21.33.94.94,0,0,1,0,.76ZM9,9A1,1,0,0,1,7,9V3A1,1,0,0,1,9,3Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm.71,17a1,1,0,0,1-1.42,0,1.15,1.15,0,0,1-.21-.33A1,1,0,0,1,9,16.25a1.05,1.05,0,0,1,.29-.71l.15-.12.18-.09.18-.06a.9.9,0,0,1,.4,0l.18.06.18.09.15.12a1,1,0,0,1,.21.33A1,1,0,0,1,10.71,17ZM11,11.25a1,1,0,0,1-2,0V3.75a1,1,0,0,1,2,0Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm.71,20.21a1,1,0,0,1-1.09.21,1.15,1.15,0,0,1-.33-.21A1,1,0,0,1,11,19.5a1.05,1.05,0,0,1,.29-.71.93.93,0,0,1,.33-.21,1,1,0,0,1,1.09.21,1.05,1.05,0,0,1,.29.71A1,1,0,0,1,12.71,20.21ZM13,13.5a1,1,0,0,1-2,0v-9a1,1,0,0,1,2,0Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm.92,25.38a1.15,1.15,0,0,1-.21.33,1,1,0,0,1-.33.21A1,1,0,0,1,15,25a.84.84,0,0,1,.08-.38.9.9,0,0,1,.54-.54.93.93,0,0,1,.57-.06.6.6,0,0,1,.19.06.76.76,0,0,1,.18.09,1.58,1.58,0,0,1,.15.12,1,1,0,0,1,.21.33.94.94,0,0,1,0,.76ZM17,19a1,1,0,0,1-2,0V7a1,1,0,0,1,2,0Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;